import type { ReactNode } from 'react';

export const symbol_event_available: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m433-313 163-163q9-9 21-8.5t21 9.5q9 9 9 21.2 0 12.19-9 20.8L454-249q-9 9-21 9t-21-9l-96-95q-9-8.61-9-20.8 0-12.2 9-21.2t21-8.5q12 .5 21 8.5l75 73ZM180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q310-861.6 310-848v28h340v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q715-861.6 715-848v28h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm0-60h600v-430H180v430Zm0-490h600v-130H180v130Zm0 0v-130 130Z"
		/>
	</svg>
);
